export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--8.ff738aef.png";